import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

const FALLBACK = ["/sito/foto-1.jpg", "/sito/foto-3.jpg", "/sito/foto-4.jpg"].map((src) => ({ id: src, src, didascalia: "" }));

export const useHomeFoto = () => {
  const [foto, setFoto] = useState([]);
  useEffect(() => {
    api.get("/public/galleria", { params: { home: true } })
      .then((r) => { const d = r.data || []; setFoto(d.length ? d.map((f) => ({ ...f, src: `${API}/public/galleria/${f.id}/image` })) : FALLBACK); })
      .catch(() => { setFoto(FALLBACK); });
  }, []);
  return foto;
};

export const HomeSlideshow = ({ foto, className = "", tid = "home-slideshow" }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (foto.length < 2) { return undefined; }
    const t = setInterval(() => { setI((v) => (v + 1) % foto.length); }, 5000);
    return () => { clearInterval(t); };
  }, [foto.length]);
  if (!foto.length) { return null; }
  const cur = foto[i % foto.length];
  return (
    <div data-testid={tid} className={`relative overflow-hidden rounded-2xl border border-white/15 bg-black/20 shadow-2xl ${className}`}>
      {foto.map((f, idx) => (
        <img key={f.id} src={f.src} alt={f.didascalia || "Foto A.N.G.E."}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${idx === i % foto.length ? "opacity-100" : "opacity-0"}`} />
      ))}
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 to-transparent p-4 pt-12">
        {cur.didascalia && <p data-testid={`${tid}-caption`} className="text-sm font-medium text-white">{cur.didascalia}</p>}
        {foto.length > 1 && (
          <div className="mt-2 flex gap-1.5">
            {foto.map((f, idx) => (
              <button key={f.id} type="button" aria-label={`Foto ${idx + 1}`} data-testid={`${tid}-dot-${idx}`} onClick={() => setI(idx)}
                className={`h-1.5 rounded-full transition-[width,background-color] ${idx === i % foto.length ? "w-6 bg-[#FBBF24]" : "w-1.5 bg-white/60"}`} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
